import { render } from "./d-good-road-item.vue?vue&type=template&id=664bc5b9&ts=true"
import script from "./d-good-road-item.vue?vue&type=script&lang=ts"
export * from "./d-good-road-item.vue?vue&type=script&lang=ts"

import "./d-good-road-item.vue?vue&type=style&index=0&id=664bc5b9&lang=scss"

import exportComponent from "D:\\project\\newb\\bnet2.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__